<template>
    <a-tabs v-model:activeKey='activeKey'>
    <a-tab-pane :key="1">
      <template #tab>
        <span>
          <EditOutlined />文字
        </span>
      </template>
      <addReply></addReply>
    </a-tab-pane>
    <a-tab-pane :key="2">
      <template #tab>
        <span>
          <PictureOutlined />图片
        </span>
      </template>
      <msgReply></msgReply>
    </a-tab-pane>
    <a-tab-pane :key="3">
      <template #tab>
        <span>
          <FileImageOutlined />图文
        </span>
      </template>
      <keyReply></keyReply>
    </a-tab-pane>
   <!-- 音频 -->
    <a-tab-pane :key="4">
      <template #tab>
        <span>
          <CustomerServiceOutlined />音频
        </span>
      </template>
      <keyReply></keyReply>
    </a-tab-pane>
   <!-- 视频 -->
    <a-tab-pane :key="5">
      <template #tab>
        <span>
          <PlaySquareOutlined />视频
        </span>
      </template>
      <keyReply></keyReply>
    </a-tab-pane>
    <template #tabBarExtraContent v-if='activeKey == 1'>
      <div class="s_flex_ali">
        <p class="s_c666 m-r-10">{{title}}</p>
        <a-tooltip>
          <template #title>
            {{qpText}}
          </template>
          <QuestionCircleOutlined class="s_c376" />
        </a-tooltip>
      </div>
    </template>
  </a-tabs>
  <div class="" v-if='activeKey == 1'>
    <a-textarea v-model:value="form.text" showCount :maxlength="600" :rows='8' placeholder='请输入' />
  </div>
  <div class="s_flex_di" v-if='activeKey == 2'>
    <div class="imgTextBox s_flex_center width49 s_po_re">
      <img v-if='form.image_detail.file_url' class="width100" style="height: 100%;"
        :src="form.image_detail.file_url.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+form.image_detail.file_url : form.image_detail.file_url"
        alt="">
      <div class="text-ac" v-if='!form.image_detail.file_url'>
        <PlusOutlined class="s_c999 fz-40" />
        <p class="s_c999">从素材库中选择</p>
      </div>
      <div class="s_po_ab_tl s_tou" v-if='!form.image_detail.file_url'>
        <wxMaterial :size='{width:621,height:250}' :groupType='1' :image="form.image_detail.file_url" :max="1"
          v-on:handlechoose="(data)=>{form.image_detail.file_url=data.imageUrl;form.image=data.data.media_id;}"
          v-on:handledel="form.image='';form.image_detail.file_url=''" />
      </div>
    </div>
    <a-button type="link" v-if='form.image_detail.file_url' @click="()=>{form.image='';form.image_detail.file_url=''}">
      删除</a-button>
  </div>
  <div class="" v-if='activeKey == 3'>
    <div class="s_flex_di" v-if='form.graphic'>
      <div class="width30 p-tb0-lr20 s_bor_cd9">
        <p class="height-52 s_flex_ali s_bor_b_cd9 m-b-15">{{form.graphic_detail.create_time}}</p>
        <img class="width100 height-250"
          :src="form.graphic_detail.list[0].image.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+form.graphic_detail.list[0].image : form.graphic_detail.list[0].image"
          alt="">
        <p class="height-52 s_flex_ali">{{form.graphic_detail.list[0].title}}</p>
      </div>
      <a-button type="link" v-if='form.graphic' @click="()=>{form.graphic='';form.graphic_detail={}}">删除</a-button>
    </div>
    <div class="s_flex_bian_c" v-else>
      <div class="imgTextBox s_flex_center width49" @click='graphicVisible = true'>
        <div class="text-ac">
          <PlusOutlined class="s_c999 fz-40" />
          <p class="s_c999">从素材库中选择</p>
        </div>
      </div>
      <div class="imgTextBox s_flex_center width48"
        @click="$router.push('/wxPublic/wxManagement/drewManagement/wx_imgText_add?type=add')">
        <div class="text-ac">
          <PlusOutlined class="s_c999 fz-40" />
          <p class="s_c999">新建图文消息</p>
        </div>
      </div>
    </div>
  </div>
   
    <div class="" v-if='activeKey == 4'>
      <div class="select_audio" v-if="!audioData.media_id" @click="audioStuts=true;">
            <PlusOutlined style="font-size:24px;height:26px"/>
            <p class="width100">选择音频</p>
      </div>
       <div class="select_success" v-else>
              <div class="audio_success">
                <img src="@/assets/images/audio.png" alt="" width="100" height="96">
                <div class="m-l-10 flex_1 s_flex_ali">
                  <p class="s_omit2 flex_1">{{audioData.name || '无'}}</p>
                </div>
              </div>
              <div class="m-l-20" >
                <span style="color:#05486A" class="cursor_p" @click="delAudio">删除</span>
              </div>
           </div>
    </div>
    <div v-if="activeKey == 5">
         <div class="s_flex_center m-t-20 m-b-50" style="width:50%;transform: translateX(30%);">
             <a-input v-model:value="viewData.wx_file_url" placeholder="请选择视频链接" style="flex:1"/>
             <a-button type="primary" class="m-l-10" @click="videoStuts=true">选择</a-button>
             <a-button type="primary" class="m-l-10 copy-btn" :data-clipboard-text="viewData.wx_file_url"  @click="copy()">复制链接</a-button>
           </div>
    </div>


  <a-button class="width-100 m-r-20 m-t-25" type="primary" v-has:msgReplySubmit='()=>onSubmit("add")'>保存</a-button>
  <a-button class="width-100 m-r-20 m-t-25" type="primary" ghost v-has:msgReplyDel='()=>onSubmit("del")'>删除回复</a-button>
  <a-modal  :keyboard="false" title="选择图文" :width='1000' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
    <graphic v-on:success='success' v-on:cancel='graphicVisible = false' />
  </a-modal>

   <a-modal  :keyboard="false" title="选择音频" :width='1300' centered :footer="null" v-model:visible="audioStuts" destroyOnClose>
    <audioModal @change="audioSelect"></audioModal>
  </a-modal>
   <a-modal :keyboard="false" title="选择视频" :width='1300' centered :footer="null" v-model:visible="videoStuts" destroyOnClose>
    <videoModal :videoID='viewData.id'   @change="videoSelect"></videoModal>
  </a-modal>
</template>
<script>
  import { EditOutlined, PictureOutlined, FileImageOutlined, QuestionCircleOutlined, PlusOutlined,CustomerServiceOutlined,PlaySquareOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import {setwx_reply,getwx_reply} from '@/api/public_wx'
  import audioModal from '../../menu/components/audioModal.vue';
    import videoModal from '../../menu/components/videoModal.vue';
  import store from "@/store";
  import Clipboard from 'clipboard';
  // 初始化默认筛选项数值
  let defForm = {
    text: '',
    image: '',
    graphic: {},
    image_detail: {},
    graphic_detail: {},
    voice:'',
    video:''
  }
  export default {
    components: { EditOutlined, PictureOutlined, FileImageOutlined, QuestionCircleOutlined, PlusOutlined,CustomerServiceOutlined,PlaySquareOutlined,audioModal,videoModal },
    setup(props) {
      const form = ref({ ...defForm });
      const state = reactive({
        graphicVisible: false,
        info: store.state.user.info,
        activeKey: 1,
        title: '文字回复可以用标签 <#微信昵称#> 显示会员微信昵称哦~',
        qpText: '后台设置：<#微信昵称#>终于等到你！ 用户关注后：高大永恒塑料制品有限公司后台 终于等到你！',
        audioStuts:false,
        videoStuts:false,
        audioData:{},
        viewData:{id:null}
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 获取信息
      const getMore = async () => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getwx_reply({key:'auto_reply'}).then(res => res.data);
        if (iscode(res)) {
          res.data.image_detail = res.data.image_detail ? res.data.image_detail : {}
          res.data.graphic_detail = res.data.graphic_detail ? res.data.graphic_detail : {}
          state.audioData = res.data.voice_detail ? res.data.voice_detail : {};
          state.viewData = res.data.video_detail ? res.data.video_detail : {}
          form.value = res.data
          setTimeout(hide);
        } else {
          message.error(res.msg);
          setTimeout(hide);
        }
      }
      //选择图文
      const success = (e) => {
        form.value.graphic_detail = e
        form.value.graphic = {
          graphic_type: e.media_id ? 1 : 2,
          graphic_id: e.id
        }
        state.graphicVisible = false
      }
      //保存
      const onSubmit = async (type) => {
        const hide = message.loading('正在加载中...', 0);
        if (type == 'del') {
          form.value = defForm
        }
        let res = await setwx_reply({
          ...form.value,
          graphic:JSON.stringify(form.value.graphic),
          key: 'auto_reply'
        }).then(res => res.data);
        setTimeout(hide);
            message.success(res.msg);
      }

      const audioSelect = function(data){
           state.audioData = data || {};
           form.value.voice = data.media_id;
           state.audioStuts = false;
      }

      const delAudio = function(){
           state.audioData = {};
           form.value.voice = '';
      }
     
      const copy = function(){
            let clipboard = new Clipboard(".copy-btn"); // 这里括号里填写上面点击事件绑定的class名

            console.log(clipboard)
            clipboard.on("success", e => {
               message.success("复制成功")
               // 释放内存
               clipboard.destroy();
            });
        }

        const videoSelect = function(data){
            console.log(data)
            state.viewData = data || {id:null};
            form.value.video = data.media_id || '';
            state.videoStuts = false
        }

      onMounted(() => {
        getMore();
      });
      return {
        ...toRefs(state),
        form,
        onSubmit,
        success,
        audioSelect,
        delAudio,
        copy,
        videoSelect
      };
    },
  };
</script>
<style lang="less" scoped>

  .imgTextBox {
    height: 250px;
    border: 1px dashed #e7e7eb;
    cursor: pointer
  }

  .imgTextBox:hover {
    border: 1px dashed #05486A;
  }

  .select_audio{
    width: 350px;
    height: 100px;
    border: 1px dashed #999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    padding: 20px 0; 
    color: #999;
    transform: translateX(100%);
    cursor: pointer;
    margin-top: 20px;
  }
  .select_success{
  width:460px;
  display: flex;
  margin: 20px 0 40px;
  transform: translateX(60%);
  align-items: center;
  word-wrap: break-word;
  word-break: break-all;
 & .audio_success{
    width: 404px;
    height: 104px;
     border: 2px solid #eee;
     overflow: hidden;
     display: flex;
      -webkit-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
   padding: 2px;
   border-radius: 5px;
  }
}
</style>